import { useEffect, useState } from "react";
import { Folder } from "lucide-react";
import { pickFolder } from "../services/folderPicker";

interface Props {
  onPick: (path: string) => void;
  label?: string;
}

export function BrowseFolderButton({ onPick, label = "Browse..." }: Props) {
  const [available, setAvailable] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const internals = (window as unknown as { __TAURI_INTERNALS__?: unknown }).__TAURI_INTERNALS__;
    setAvailable(Boolean(internals));
  }, []);

  if (!available) return null;

  async function handleClick() {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      const result = await pickFolder();
      switch (result.kind) {
        case "ok":
          onPick(result.path);
          break;
        case "cancelled":
        case "no-tauri":
          // No user-visible error — they cancelled or we're not in Tauri.
          break;
        case "error":
          setError(result.message || "Could not open folder picker");
          break;
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ display: "inline-flex", flexDirection: "column", gap: 4 }}>
      <button
        type="button"
        className="button secondary"
        onClick={() => void handleClick()}
        disabled={busy}
        title="Open native folder picker"
      >
        <Folder size={14} />
        <span>{busy ? "Opening..." : label}</span>
      </button>
      {error && (
        <span className="rail-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
